
<div class="error-container">
  <div class="error-logo">
    <img src="../../../assets/images/error icon.png" alt="">
  </div>
  <div class="error-message">
    <div class="label1">Uh-oh... Something went wrong!</div>
    <div class="label2">Please try again in a while...</div>
  </div>
</div>